import {
    CardCvcElement, CardElement, CardExpiryElement, CardNumberElement,
    useElements, useStripe
} from "@stripe/react-stripe-js";
import axios from "axios";
import { forwardRef, useImperativeHandle, useState } from "react";
import CONFIG from "../../../../../utils/config";
import API_LIST from "../../../../../utils/apiList";
import "./StripePaymentMethodPanel.scss"
import _ from "lodash";
import { useDispatch } from "react-redux";
import { paymentUpdateMembershipPage } from "../../../../../redux/checkout/actions";
import useLogin from "../../../../../custom-hooks/useLogin";
import { SessionKeys } from "../../../../../utils/AppUtils";
import { updateSubscriptionCardInfo } from "../../../../../redux/payment/actions";

const StripePaymentMethodPanel = forwardRef((props, ref) => {

    const {
        paymentIntentInfo, setPaymentInProcess,
        setErrorMsg, enableFormField, subscriptionId
    } = props

    const dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();

    const {isLoggedIn} = useLogin()

    const [cardNumberError, setCardNumberError] = useState("");
    const [cardCVVError, setCardCVVError] = useState("");
    const [cardExpError, setCardExpError] = useState("");

    useImperativeHandle(ref, () => ({
        handleStripeSubmit(formData) {
            console.log('Handle Stripe Submit')
            
            addStripePaymentMethod(formData);
        }
    }))

    /**
     * ON Client side, payment method is added.
     * And send to backend for attaching it to customer.
     * @param {*} formData 
     */
    const addStripePaymentMethod = async (formData) => {
        console.log(formData);
        await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardNumberElement),
            billing_details: {
                name: `${formData.firstName} ${formData.lastName}`,
                email: formData.contactEmail,
                phone: formData.phoneNumber,
                address: {
                    line1: formData.addressLine1,
                    line2: formData.addressLine2,
                    city: formData.city,
                    state: formData.state,
                    postal_code: formData.postalCode,
                    country: formData.country,
                },
            }
        })
        .then((result) => {
            console.log(result)
            if (!_.isEmpty(result) && !_.isEmpty(result?.paymentMethod)
            && result?.paymentMethod.id
            ) {
                sendPaymentUpdateResponseToBackend(result, result.paymentMethod.id);
            }
        })
        .catch((error) => {
            console.log(error)
            setErrorMsg(error?.message);
            setPaymentInProcess(false);
        })
    }


    const sendPaymentUpdateResponseToBackend = (response, paymentMethodId) => {
        dispatch(
            updateSubscriptionCardInfo({
                URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.UPDATE_PAYMENT_DETAIL}`,
                isJSON: true,
                method: "post",
                payload: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    subscription_id: subscriptionId,
                    stripe_response: response,
                    payment_method_id: paymentMethodId
                }
            })
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <div className="input-text ">
                            <label
                                htmlFor="cardNumber"
                                className="input__label"
                            >
                                Card Number<span>*</span>
                            </label>
                            <div className="card-input-element input__field">
                                <CardNumberElement disabled={!enableFormField} />
                            </div>
                            <span className="error-message">{cardNumberError}</span>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <div className="input-text ">
                            <label
                                htmlFor="cardCVC"
                                className="input__label"
                            >
                                CVC<span>*</span>
                            </label>
                            <div className="card-input-element input__field">
                                <CardCvcElement disabled={!enableFormField} />
                            </div>
                            <span className="error-message">{cardCVVError}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <div className="input-text ">
                            <label
                                htmlFor="cardExpiry"
                                className="input__label"
                            >
                                Expiration Month / Year<span>*</span>
                            </label>
                            <div className="card-input-element input__field">
                                <CardExpiryElement disabled={!enableFormField} />
                            </div>
                            <span className="error-message">{cardExpError}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
})

export default StripePaymentMethodPanel